export enum Category {
  Size = "size",
  Dough = "dough",
  Sauce = "sauce",
  Cheese = "cheese",
  Vegetables = "vegetables",
  Meat = "meat",
}
